import React from 'react';
import { bool } from 'prop-types';
import {
  Card,
  SkeletonContent,
  SkeletonBlock,
  SkeletonLine
} from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import {
  defaultCardContentProps,
  showAboveSmBreakpoint,
  showBelowSmBreakpoint
} from '../../constants/responsiveClassNames';

const QuotesDetailsBoxLoading = () => (
  <Card
    data-component="QuotesDetailsBoxLoading"
    data-testid="quotes-details-box-loading"
    className="@sm:sui-min-w-96 sui-w-full sui-h-full"
  >
    <div className="sui-flex sui-justify-between">
      <SkeletonContent disablePadding initialSize="1/4">
        <SkeletonBlock aspect="wide" height={6} />
      </SkeletonContent>
      <SkeletonContent disablePadding initialSize="1/4">
        <SkeletonBlock aspect="wide" height={6} />
      </SkeletonContent>
    </div>
    <SkeletonContent disablePadding className="sui-w-full">
      <div className={showBelowSmBreakpoint}>
        <SkeletonLine variant="multi" numberOfLines={2} />
      </div>
      <div className={showAboveSmBreakpoint}>
        <SkeletonLine variant="multi" numberOfLines={3} />
      </div>
    </SkeletonContent>
  </Card>
);

const QuotesLoading = React.forwardRef(({ showTabs }, ref) => {

  return (
    <Card
      data-component="QuotesLoading"
      data-testid="quotes-container-loading"
      className="sui-@container"
      CardContentProps={{ className: classNames(defaultCardContentProps, 'sui-w-full') }}
      ref={ref}
    >
      {/* Header Section */}
      <div className="sui-flex sui-justify-between">
        <SkeletonContent disablePadding initialSize="1/4">
          <SkeletonBlock aspect="wide" height={8} />
        </SkeletonContent>
        <div className={classNames(showAboveSmBreakpoint, 'sui-w-1/4')}>
          <SkeletonBlock aspect="wide" height={8} />
        </div>
      </div>

      {/* Tabs (if needed) */}
      {showTabs ? (
        <SkeletonBlock aspect="wide" height={12} />
      ) : null}

      {/* Quotes Content Section - Responsive */}
      <div
        className={classNames(
          'sui-flex sui-flex-col @sm:sui-flex-row @sm:sui-flex-nowrap',
          'sui-gap-3 @sm:sui-gap-4 sui-w-full @sm:sui-overflow-auto'
        )}
      >
        {Array.from({ length: 4 }, (item, index) => (
          <div
            key={index + 1}
            className={classNames(
              index >= 3 ? 'sui-hidden @sm:sui-block' : ''
            )}
          >
            <QuotesDetailsBoxLoading />
          </div>
        ))}
      </div>

      {/* Mobile-only bottom skeleton block */}
      <div className={classNames(showBelowSmBreakpoint, 'sui-mt-8')}>
        <SkeletonBlock aspect="wide" height={11} />
      </div>
    </Card>
  );
});

QuotesLoading.propTypes = {
  showTabs: bool,
};

QuotesLoading.defaultProps = {
  showTabs: true,
};

QuotesLoading.displayName = 'QuotesLoading';

export default QuotesLoading;